// extracted by mini-css-extract-plugin
module.exports = {"portlet":"Portlet_portlet__3OoVI"};